import { useState, useMemo, useCallback, useContext } from 'react'
import produce from 'immer'

import useScid from 'common/use-scid'
import ContentManagementContext, { BulkContentItem, ContentType } from '../../../ContentManagementProvider/Context'
import { useValidation } from '../components/ValidationMessage'
import { ContentModalProps } from '..'
import ContentModalContext from './Context'

type IContentModalProviderProps = { children: React.ReactNode } & ContentModalProps

const ContentModalProvider = ({ children, show, onHide, contentItem, type }: IContentModalProviderProps) => {
  const { onSaveContentItem, onDeleteContentItem } = useContext(ContentManagementContext)
  const scid = useScid()
  const validation = useValidation()
  const [imageUploadOpen, setImageUploadOpen] = useState(false)
  const [selectedCategories, setSelectedCategories] = useState<string[]>()
  const [selectedAcademicFocuses, setSelectedAcademicFocuses] = useState<string[]>()
  const [exceed5Tags, setExceed5Tags] = useState(false)

  const [item, setItem] = useState<any>(contentItem) // TODO: type this
  const isEditing = useMemo(() => !!contentItem.Id, [contentItem.Id])

  const onUpdateField = useCallback(
    (field: string, value: any) => {
      const updated = produce(item, (draft: any) => {
        draft[field] = value
      })
      setItem(updated)
      return updated
    },
    [item],
  )

  const onUpdateFields = useCallback((updates: object) => {
    setItem((previousItem: any) => {
      return {
        ...previousItem,
        ...updates,
      }
    })
  }, [])

  const onHideModal = useCallback(() => {
    setItem(contentItem)
    onHide()
  }, [contentItem, onHide])

  const onDeleteItem = useCallback(() => {
    const deleteItemObject: BulkContentItem = { id: item.Id, contentType: type as ContentType }
    onDeleteContentItem(deleteItemObject)
  }, [item.Id, type, onDeleteContentItem])

  const onSaveItem = useCallback(() => {
    onSaveContentItem(item.ContentType, item, contentItem)
  }, [contentItem, item, onSaveContentItem])

  return (
    <ContentModalContext.Provider
      value={{
        scid,
        show: !imageUploadOpen && show,
        item,
        type,
        isEditing,
        setImageUploadOpen,
        onUpdateField,
        onUpdateFields,
        onHideModal,
        onSaveItem,
        onDeleteItem,
        validation,
        selectedCategories,
        setSelectedCategories,
        selectedAcademicFocuses,
        setSelectedAcademicFocuses,
        exceed5Tags,
        setExceed5Tags,
      }}
    >
      {children}
    </ContentModalContext.Provider>
  )
}

export default ContentModalProvider
